"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoorDashStatusCallbackSchema = exports.DoorDashDeliverySchema = exports.DoorDashQuoteSchema = exports.DoorDashStatusSchema = void 0;
exports.doorDashStatusToOrderStatus = doorDashStatusToOrderStatus;
const zod_1 = require("zod");
// DoorDash Drive delivery_status values we observe on the create response + callbacks.
exports.DoorDashStatusSchema = zod_1.z.enum([
    'created',
    'confirmed',
    'enroute_to_pickup',
    'arrived_at_pickup',
    'picked_up',
    'enroute_to_dropoff',
    'arrived_at_dropoff',
    'delivered',
    'cancelled',
]);
// Response of POST /drive/v2/quotes — fee is in CENTS (DoorDash convention).
exports.DoorDashQuoteSchema = zod_1.z.object({
    external_delivery_id: zod_1.z.string(),
    fee: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().default('USD'),
    duration: zod_1.z.number().nonnegative().optional(), // minutes
    dropoff_eta: zod_1.z.string().optional(), // ISO8601
});
// Response of POST /drive/v2/deliveries (delivery created/dispatched).
exports.DoorDashDeliverySchema = zod_1.z.object({
    external_delivery_id: zod_1.z.string(),
    delivery_status: exports.DoorDashStatusSchema,
    fee: zod_1.z.number().nonnegative().optional(),
    currency: zod_1.z.string().default('USD'),
    tracking_url: zod_1.z.string().optional(),
    dropoff_eta: zod_1.z.string().optional(),
});
// Webhook callback body DoorDash POSTs to our status endpoint.
exports.DoorDashStatusCallbackSchema = zod_1.z.object({
    external_delivery_id: zod_1.z.string(),
    event_name: zod_1.z.string(),
    delivery_status: exports.DoorDashStatusSchema,
    tracking_url: zod_1.z.string().optional(),
});
// Translate a DoorDash status into our pos-orders lifecycle status, or null
// when the callback should NOT advance the order (created/confirmed/cancelled
// are handled outside the delivering→delivered fast path).
function doorDashStatusToOrderStatus(s) {
    switch (s) {
        case 'enroute_to_pickup':
        case 'arrived_at_pickup':
        case 'picked_up':
        case 'enroute_to_dropoff':
        case 'arrived_at_dropoff':
            return 'delivering';
        case 'delivered':
            return 'delivered';
        default:
            return null;
    }
}
//# sourceMappingURL=doordash.schema.js.map